import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const logImagesState = atom<boolean>({
  key: 'logImagesState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
